export function FormatDaysOnProject({ days, daysSpent}) {
    if (!days) {
        return <div></div>
    }
    return (
        <div className="days-on-project">
            {days}
            {daysSpent <= days ? (
                <span> (zbývá <span className="success-color"> {days - daysSpent}</span> d.)</span>
            ) : (
                <span> (přečerpáno <span className="not-success-color"> {daysSpent - days}</span> d.)</span>
            )}
        </div>
    );
}

